import { useEffect, useState } from "react";
import api from "../../api/axios";
import "./ZapierIntegrationPage.css";

const ZapierIntegrationPage = () => {
  const workspaceId = "eca5db98-571b-4735-81b4-505676753b64";

  const [integration, setIntegration] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showToken, setShowToken] = useState(false);
  const [error, setError] = useState("");



  
  useEffect(() => {
   

    fetchIntegration();
  }, []);
  
 const fetchIntegration = async () => {
  try {
    const res = await api.get(
      `/integrations/zapier?workspaceId=${workspaceId}`
    );

    // Axios already parses JSON
    const data = res.data;

    if (data && data.token) {
      setIntegration({
        webhookUrl: `${process.env.REACT_APP_API_BASE_URL}/api/integrations/zapier/import`,
        token: data.token,
      });
    } else {
      setIntegration(null);
    }

  } catch (err) {
    console.error("Integration fetch failed:", err);
    setIntegration(null);
  }
};

  const createIntegration = async () => {
    try {
      setLoading(true);
      setError("");

      const res = await api.post(
        "/integrations/zapier/create",
        { workspaceId }
      );

      setIntegration(res.data);
    } catch (err) {
      setError("Failed to create integration");
    } finally {
      setLoading(false);
    }
  };

  const copyToClipboard = (value) => {
    navigator.clipboard.writeText(value);
  };

  const maskedToken = (token) => {
    if (!token) return "";
    return token.slice(0, 6) + "••••••••••••••••";
  };

  return (
    <div className="container mt-5">
      <div className="card shadow-sm zapier-card">
        <div className="card-body">

          {/* Header */}
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h4 className="mb-0">Zapier Integration</h4>
            <span
              className={`badge ${
                integration ? "bg-success" : "bg-danger"
              }`}
            >
              {integration ? "Connected" : "Not Connected"}
            </span>
          </div>

          {/* Enable Button */}
          {!integration && (
            <button
              className="btn btn-primary"
              onClick={createIntegration}
              disabled={loading}
            >
              {loading ? "Creating..." : "Enable Zapier"}
            </button>
          )}

          {/* Integration Details */}
          {integration && (
            <>
              <div className="mb-4">
                <label className="form-label fw-semibold">
                  Webhook URL
                </label>
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    value={integration.webhookUrl}
                    readOnly
                  />
                  <button
                    className="btn btn-outline-secondary"
                    onClick={() =>
                      copyToClipboard(integration.webhookUrl)
                    }
                  >
                    Copy
                  </button>
                </div>
              </div>

              <div className="mb-4">
                <label className="form-label fw-semibold">
                  API Key
                </label>
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    value={
                      showToken
                        ? integration.token
                        : maskedToken(integration.token)
                    }
                    readOnly
                  />
                  <button
                    className="btn btn-outline-secondary"
                    onClick={() => setShowToken(!showToken)}
                  >
                    {showToken ? "Hide" : "View"}
                  </button>
                  <button
                    className="btn btn-outline-secondary"
                    onClick={() =>
                      copyToClipboard(integration.token)
                    }
                  >
                    Copy
                  </button>
                </div>
              </div>

              {/* Setup Instructions */}
              <div className="alert border">
                <h6 className="fw-bold">Setup in Zapier</h6>
                <ol className="mb-0">
                  <li>Create a new Zap.</li>
                  <li>Select your CRM (Salesforce, HubSpot, etc.) as Trigger.</li>
                  <li>Select “Webhooks by Zapier” → POST.</li>
                  <li>Paste the Webhook URL above.</li>
                  <li>
                    Add Header:
                    <br />
                  
                  </li>
                </ol>
              </div>
            </>
          )}

          {error && (
            <div className="alert alert-danger mt-3">
              {error}
            </div>
          )}

        </div>
      </div>
    </div>
  );
};

export default ZapierIntegrationPage;
